/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bound } from './bound';

/**
 * 旅程情報
 */
export interface GetOrderResponseDataAir {
  /**
   * 旅程区分<br/> domestic：日本国内単独旅程<br/> international：国際旅程
   */
  tripType?: GetOrderResponseDataAir.TripTypeEnum;
  /**
   * 欠航有無<br/> セグメントステータスがUNであるセグメントが存在する場合にtrue
   */
  isContainedCancelledFlight?: boolean;
  /**
   * 欠航となったNHグループ便名NHグループ運航の有無<br/> セグメントステータスがUNであるNHグループ便名NHグループ運航の便が存在する場合にtrue
   */
  isContainedCancelledNhFlight?: boolean;
  /**
   * 一部搭乗済みであるか<br/> クーポンステータスが使用済みであるｅチケットが存在する場合にtrue
   */
  isPartiallyBoarded?: boolean;
  /**
   * NHグループ便名セグメント有無<br/> NHグループ便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupMarketingSegment?: boolean;
  /**
   * NHグループ運航セグメント有無<br/> NHグループ運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupOperatingSegment?: boolean;
  /**
   * 他社便名セグメント有無<br/> 他社便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierMarketingSegment?: boolean;
  /**
   * 他社運航セグメント有無<br/> 他社運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierOperatingSegment?: boolean;
  /**
   * 空席待ちセグメント有無<br/> セグメントステータスが空席待ち(設定ファイルに定義)であるセグメントが存在する場合にtrue
   */
  isContainedWaitlistedSegment?: boolean;
  /**
   * スケジュールチェンジセグメント有無<br/> スケジュールチェンジが発生しているかがtrueであるセグメントが存在する場合にtrue
   */
  isContainedScheduleChangedFlight?: boolean;
  /**
   * クレジットカードのみ決済可能か否か<br/>　クレジットカードのみ決済可能である場合にtrue
   */
  isCreditCardOnlyFare?: boolean;
  /**
   * 社用運賃適用対象か否か<br/> 社用運賃適用対象である場合にtrue
   */
  isCompanyStaffFare?: boolean;
  /**
   * 介護運賃割引有無<br/> 介護運賃割引が適用されている場合にtrue
   */
  isContainedCaregiverDiscountFare?: boolean;
  /**
   * 最上位キャビンクラス<br/> 国際旅程で日本発着国際線がある場合は、そのセグメントのうち最上位のキャビンクラス、そうでない場合は全セグメントのキャビンクラスの内、最上位のものを返却する<br/> eco：エコノミー<br/> ecoPremium：プレミアムエコノミー<br/> business：ビジネス<br/> first：ファースト
   */
  highestCabinClass?: GetOrderResponseDataAir.HighestCabinClassEnum;
  /**
   * バウンドリスト<br/> ※以下のいずれかの条件に該当するセグメントは返却しない<br/> 1.ステータスがパッシブセグメント(対象となるステータスは設定ファイルに定義)<br/> 2.ステータスがゴーストセグメント(対象となるステータスは設定ファイルに定義)<br/> 3.キャリアコード未指定(キャリアコード＝YYとしてDxAPIから返却)のOPEN便<br/> 4.Informative Segment<br/> 5.フリーテキストに\"WEB//@IGNORE\"を含むRMエレメントがリレートしているセグメント<br/> <dt>※アップグレード空席待ちのセグメント(UPG-後便と記載)がある場合、以下の通りに処理を行い、アップグレード前のセグメント(UPG-前便と記載)とマージして返却する</dt> <dd>1.SSR FQTU/STARまたはSK PUPGがリレートしているFlightIDより、UPG-後便を特定する<br/> UPG-後便が特定出来なかった場合は処理2以降を実施しない<br/> UPG-後便が座席確約ステータスの場合は処理2以降を実施しない</dd> <dd>2.UPG-後便と出発日・販売キャリアコード・便番号が同一のFlightIDより、UPG-前便を特定する。<br/> ※UPG-前便とFlightIdが重複する便はUPG-後便とみなさない<br/> UPG-前便が特定出来なかった場合は処理3以降を実施しない</dd> <dd>3.UPG-前便のセグメントをUPG-後便のセグメントに対して上書く。<br/> ※UPG-後便はアップグレード空席待ち情報に保持される<br/> ーーーーーーーーー<br/> 【上書きしない項目】<br/> connectionTime<br/> departureDaysDifference<br/> arrivalDaysDifference<br/> ーーーーーーーーー</dd> <dd>4.UPG-前便のセグメント及びバウンドは返却しない</dd> <dt>※メジャースケジュールチェンジが発生しているバウンドがある場合、以下の通りに処理を行う。</dt> <dd>1.バウンドのoriginalFlightsに存在する欠航便(UN便)をセグメント毎にバウンドを別に生成して返却する。<br/> このとき、生成したバウンドのflightsの情報にはもとのバウンドのoriginalFlightsの情報を設定する。</dd> <dd>2.欠航便(UN便)のairBoundIdは「UNX」(X：1から始まる連番)とする</dd> <dd>3.バウンドを返却する際、出発日時でソートをかけて返却を行う。OPEN便の場合は、一番下に返却する。</dd>
   */
  bounds?: Array<Bound>;
  /**
   * ルフトハンザサイトで座席指定可能なセグメント有無<br/> 以下の条件を満たす場合、trueを返却する<br/> 1 IATAエリアを跨いでいる<br/> 2 LH運航である<br/> 3 キャビンクラスが、設定ファイルに定義したルフトハンザ便のdeeplink対象キャビンクラスである
   */
  isContainedSeatRequestableSegmentInLHSite?: boolean;
  /**
   * 暗号化済みLHサイト連携パラメータ<br/> ルフトハンザサイトで座席指定可能なセグメント有無がtrueの場合、返却する。<br/> ※G03_共通処理（514_暗号化）を用いてAES形式にて暗号化を行う。<br/> ※暗号化キーは設定ファイルにて管理する。
   */
  encryptDataForLHSite?: string;
  /**
   * 香港発着セグメントを含むか<br/> 出発地または到着地が香港であるセグメントが旅程に含まれる場合にtrue
   */
  isContainedHongKongSegment?: boolean;
  /**
   * 中国発(香港・台湾・マカオ含まず)または中国経由便が含まれるかどうか<br/> 旅程中に中国発(香港・台湾・マカオ含まず)セグメント、または中国経由便(同一セグメント内での中国国内での途中降機)を含む場合true
   */
  isContainedChinaSegmentIncludesStops?: boolean;
  /**
   * アイきっぷ運賃有無<br/> 以下の全ての条件に合致する場合、true<br/> 1.特典PNR区分がfalse<br/> 2.旅程区分が日本国内単独旅程(domestic)である<br/> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.Fare Basisの7桁目がアイきっぷ運賃Fare Basis(設定ファイルに定義)と合致するセグメントが旅程に含まれる
   */
  isContainedRemoteIslandFare?: boolean;
  /**
   * 障がい者割引運賃有無<br/> Ticket designatorに設定ファイルに定義した障がい者割引運賃Ticket designatorが含まれているセグメントが旅程に存在する場合にtrue
   */
  isContainedDisabilityDiscountFare?: boolean;
  /**
   * 年齢制限のある割引運賃有無<br/> 以下の全ての条件に合致する場合、true<br/> 1.特典PNR区分がfalse<br/> 2.旅程区分が日本国内単独旅程(domestic)である<br/> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.Fare Basisの7桁目がスマートシニア空割Fare basis(設定ファイルに定義)、スマートU25Fare basis(設定ファイルに定義)のいずれかと合致するセグメントが旅程に含まれる
   */
  isContainedAgeLimitedFares?: boolean;
  /**
   * ビジネスきっぷ運賃有無<br/> 以下の全ての条件に合致する場合、true<br/> 1.特典PNR区分がfalse<br/> 2.旅程区分が日本国内単独旅程(domestic)である<br/> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.Fare Basisの7桁目がビジネスきっぷ運賃Fare basis(設定ファイルに定義)、プレミアムビジネスきっぷFare basis(設定ファイルに定義)のいずれかと合致するセグメントが旅程に含まれる
   */
  isContainedBusniessKippuFares?: boolean;
  /**
   * 株主優待運賃有無<br/> 以下の全ての条件に合致する場合、true<br/> 1.有償PNRである<br/> 2.日本国内単独旅程である<br/> 3.出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.Fare basisの7桁目が設定ファイルに定義した株主優待運賃Fare basisに合致するセグメントが旅程に含まれる
   */
  isContainedShareholdersBenefitDiscountFare?: boolean;
  /**
   * 後日回収型株主優待運賃有無<br/> 以下の全ての条件に合致する場合、true<br/> 1.有償PNRである<br/> 2.日本国内単独旅程である<br/> 3.出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.Fare basisの7桁目が設定ファイルに定義した後日回収型株主優待運賃Fare basisに合致するセグメントが旅程に含まれる
   */
  isContainedShareholdersBenefitDiscountFareByPostCollection?: boolean;
  /**
   * 包括旅行運賃有無<br/> PNR作成オフィスコードの4文字目から8文字目までの文字列が、設定ファイルの「包括旅行運賃(IIT)を販売するオフィスレンジ」に含まれる。
   */
  isContainedInclusiveTourFare?: boolean;
  /**
   * 国会議員クーポン支払有無<br/> 以下の全ての条件に該当する場合にtrue<br/> 1.ドキュメント種別が航空券である<br/> 2.航空券支払情報IDがHRDIETまたはHCDIETである
   */
  isContainedLawmakerCouponPayment?: boolean;
  /**
   * アップグレード済である日本国内線のセグメント有無<br/> アップグレード区分が空欄でない日本国内線のセグメントが含まれる場合true
   */
  isContainedUpgradedJapanDomesticSegment?: boolean;
  /**
   * 全バウンドがNo Showとなったセグメントのみのバウンドかどうか<br/> 全セグメントの航空券情報が以下の全ての条件に該当する場合にtrue<br/> 1.クーポンステータスが未使用であること(設定ファイルに定義)<br/> 2.出発済であること(操作日時>出発日時)<br/> ※DxAPIから返却されるセグメントの出発日時は、その空港のタイムゾーンの時刻となっているため、タイムゾーンを考慮した時刻換算を行って比較を行う。空港ごとの時差はASWDBより取得する。
   */
  isAllBoundsNoShow?: boolean;
  /**
   * 日本国内線のセグメントが含まれるか<br/> 日本国内線のセグメントが含まれる場合true
   */
  isContainedJapanDomesticSegment?: boolean;
  /**
   * Dynamic Waiver Refund対象便有無<br/> Waiverコードが存在する場合true<br/> ※\"cancelAndRefund\"を格納したtargetActionと、予約番号を指定して呼び出したDxAPI(GET /purchase/order-eligibilities)で、Dynamic Waiver Refund対象便の場合
   */
  isContainedDynamicWaiverRefundFlight?: boolean;
  /**
   * Dynamic Waiver Change対象便有無<br/> Waiverコードが存在する場合true<br/> ※予約番号を指定して呼び出したDxAPI(GET /purchase/orders)の「orderEligibilities > change」の「waiverCodes」で、Dynamic Waiver Change対象便の場合
   */
  isContainedDynamicWaiverChangeFlight?: boolean;
  /**
   * 全バウンドがバウンド毎不可条件に該当するかどうか<br/> バウンド毎不可条件に該当するバウンドかどうかが全バウンドでtrueの場合true
   */
  isAllBoundsNotEligible?: boolean;
  /**
   * 搭乗可能なINF数を超えたセグメント有無<br/> SSRステータスがNOであるSSR INFTが、旅程内の未出発の便に存在する場合にtrue
   */
  isContainedInfantQuotaShortageSegment?: boolean;
  /**
   * イレギュラー対象便を含むか<br/> イレギュラー対象便を含む場合にtrue<br/> イレギュラー対象便はセグメントステータスに下記が含まれるか否かで判別する<br/> KK/HN/NA/TN/UU/UC/US/NO/HX/IW/TK/TL/UN(設定ファイルに定義)
   */
  isContainedIrregularFlights?: boolean;
  /**
   * Suffix便を含むか<br/> Suffix便、かつ出発まで48時間以内のセグメントが含まれる場合にtrue
   */
  isContainedSuffix?: boolean;
  /**
   * 出発日の第1便がDCS移行開始日付以降かどうか<br/> 設定ファイルに定義したDCS移行開始日付≦第1便の出発日 を満たす場合true
   */
  isAfterDcsMigrationTrip?: boolean;
}
export namespace GetOrderResponseDataAir {
  export type TripTypeEnum = 'domestic' | 'international';
  export const TripTypeEnum = {
    Domestic: 'domestic' as TripTypeEnum,
    International: 'international' as TripTypeEnum,
  };
  export type HighestCabinClassEnum = 'eco' | 'ecoPremium' | 'business' | 'first';
  export const HighestCabinClassEnum = {
    Eco: 'eco' as HighestCabinClassEnum,
    EcoPremium: 'ecoPremium' as HighestCabinClassEnum,
    Business: 'business' as HighestCabinClassEnum,
    First: 'first' as HighestCabinClassEnum,
  };
}
